export default "__VITE_ASSET__C7_ZgjsE__"